module.exports = __webpack_public_path__ + "img/logo-antiga.5fe88121.png";